import { Injectable } from '@angular/core';
import type { IccIcon } from '../../icons';

@Injectable({
    providedIn: 'root',
})
export class IconRegistryService {
    private registry = new Map<string, string>();
    private elementRegistry = new Map<string, SVGElement>();

    public registerIcons(icons: IccIcon[]): void {
        icons.forEach((icon: IccIcon) => this.registry.set(icon.name, icon.data));
    }

    public getIcon(iconName: string): string | undefined {
        if (!this.registry.has(iconName)) {
            console.warn(
                `We could not find the icon with the name ${iconName}, did you add it to the Icon registry?`
            );
        }
        return this.registry.get(iconName);
    }

    public getIconElement(iconName: string, document: Document): SVGElement {
        if (!this.elementRegistry.has(iconName)) {
            const svgData = this.getIcon(iconName);
            if (svgData) {
                const svgElement = this.svgElementFromString(document, svgData);
                this.elementRegistry.set(iconName, svgElement);
                return svgElement;
            }
        }
        return this.elementRegistry.get(iconName)?.cloneNode(true) as SVGElement;
    }

    private svgElementFromString(document: Document, svgContent: string): SVGElement {
        const div = document.createElement('DIV');
        div.innerHTML = svgContent;
        return (
            div.firstElementChild as SVGElement ||
            document.createElementNS('http://www.w3.org/2000/svg', 'path')
        );
    }
}
